var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$store.getters['resource/currentResource'].key},[_c('help',{attrs:{"text":_vm.$t('help.invite_create'),"title":_vm.$t('help.invite_create_title')}}),_c('div',{staticClass:"white-container"},[_c('invite-view',{on:{"save":_vm.saveInvite}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }